/*jshint esversion: 6 */
import Smooth from 'smooth-scrolling';
import classes from 'dom-classes';
import {getDistance, LoadMaskImage, animateChildren} from '../helpers';

import {TweenMax, Power4, Expo} from "gsap";
import CustomEase from '../../vendors/CustomEase';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
require('slick-carousel/slick/slick.js');


class MeetingsScroll {
    constructor(el) {
        this.el = el;
        this.el.header = $('#siteHeader');
        this.el.logo = this.el.header.find('.logo');
        this.el.hamMenu = this.el.header.find('.hamburger button');

        new SmoothScroll({
            preload: false,
            noscrollbar: !CCM_EDIT_MODE,
            native: CCM_EDIT_MODE,
            direction: CCM_EDIT_MODE ? 'vertical' : 'horizontal',
            ease: 0.06,
            section: this.el[0],
            divs: this.el.find('.pages-container .page'),
            logo: this.el.logo,
            header: this.el.header,
            hamMenu: this.el.hamMenu,
            maskImages: this.el.find('.mask-image'),
            animateChildren: this.el.find('.animate-children')
        }).init();
    }
}

class SmoothScroll extends Smooth {
    constructor(opt) {
        super(opt);
        
        classes.remove(opt.section, 'no-js');

        this.createExtraBound();
        
        this.resizing = false;
        this.cache = null;
        this.blackCache = null;
        this.maskImageCache = null;
        this.animateCache = null;
        this.runningAnimations = [];
        this.native = opt.native;

        this.dom.navigation = $(opt.section).next();

        this.dom.divs = Array.prototype.slice.call(opt.divs, 0);
        this.dom.logo = opt.logo;
        this.dom.hamMenu = opt.hamMenu;
        this.dom.header = opt.header;
        this.dom.tabs = this.dom.header.find('.tabs a');
        this.dom.blackBlocks = Array.prototype.slice.call(opt.divs.filter('.black-block'), 0);
        this.dom.maskImages = Array.prototype.slice.call(opt.maskImages, 0);
        this.dom.team = opt.divs.filter('.page--team');
        this.dom.clients = opt.divs.find('.clients-block__link');
        this.dom.workWithUs = opt.divs.filter('.page__work-with-us');
        this.dom.animate = Array.prototype.slice.call(opt.animateChildren, 0);
        
        this.dom.teamSection = opt.divs.filter('#teamSection')[0];
        this.dom.contactSection = opt.divs.filter('#contactSection')[0];

        window.smoothScrollInstances.push(this);
    }
    
    createExtraBound() {
        ['getCache', 'inViewport', 'off', 'on', 'loadImage', 'handleMouseOver', 'handleMouseLeave', 'animate', 'hoverClientsAnimationEnter', 'hoverClientsAnimationLeave']
        .forEach((fn) => this[fn] = this[fn].bind(this));
    }
    
    on() {
        super.on();

        this.dom.team.on('mouseenter', this.handleMouseOver);
        this.dom.team.eq(0).trigger('mouseenter');

        this.dom.clients
            .on('mouseenter', this.hoverClientsAnimationEnter)
            .on('mouseleave', this.hoverClientsAnimationLeave);

        this.dom.workWithUs
            .on('mouseenter', this.hoverWorkAnimationEnter.bind(this))
            .on('mouseleave', this.hoverWorkAnimationLeave);

    }

    handleMouseOver(e, page = null) {
        const that = this, element = page || $(e.currentTarget);
        if(this.resizing) return;
        
        this.handleMouseLeave(element);
        element.addClass('hovering');
    }

    handleMouseLeave(e) {
        const that = this, element = $(e).siblings('.hovering');
        if(this.resizing) return;
        
        element.removeClass('hovering'); 
    }

    hoverWorkAnimationEnter(e) {
        const el = $(e.currentTarget);

        this.handleMouseLeave(el);
        
        TweenMax.staggerTo(
            el.find('p'),
            0.6,
            {y: -100, ease: Expo.easeInOut},
            0.03
        );
        
    }
    
    hoverWorkAnimationLeave(e) {
        const el = $(this);
        TweenMax.staggerTo(
            el.find('p').get().reverse(),
            0.6,
            {y: 0, ease: Expo.easeInOut},
            0.03
        );  
    }

    hoverClientsAnimationEnter(e) {
        this.dom.clients.not(e.currentTarget).addClass('hovering');
    }

    hoverClientsAnimationLeave() {
        this.dom.clients.removeClass('hovering');
    }

    resize() {

        this.resizing = true;

        this.getCache();
        super.resize();

        if(this.native) {
            this.dom.scroll.style.width = '';
            this.dom.scroll.style.height = `${this.vars.bounding}px`;
        }

        this.resizing = false;
    }

    getCache() {

        this.cache = [];
        this.blackCache = [];
        this.maskImageCache = [];
        this.animateCache = [];

        const unit = (this.vars.width / 3);
        
        let boundingTotal = 0;

        this.dom.divs.forEach((el, index) => {

            el.style.display = 'inline-block';
            el.style.transform = 'none';

            if(classes.has(el, 'page-60')) {
                boundingTotal += unit * 2;
                el.style.width = `${unit * 2}px`;
            }
            else if(classes.has(el, 'page-20')) {
                boundingTotal += unit * 0.7;
                el.style.width = `${unit * 0.7}px`;
            }
            else {
                boundingTotal += unit;
                el.style.width = `${unit}px`;                
            }
            
            const scrollX = this.vars.target;
            const bounding = el.getBoundingClientRect();
            const bounds = {
                el: el,
                state: true,
                left: bounding.left + scrollX,
                right: bounding.right + scrollX,
                center: unit / 2,
                isBlack: classes.has(el, 'black-block')
            };

            this.cache.push(bounds);
        });

        this.dom.blackBlocks.forEach((el, index) => {
            const scrollX = this.vars.target;
            const bounding = el.getBoundingClientRect();
            const bounds = {
                el: el,
                state: true,
                left: bounding.left + scrollX,
                right: bounding.right + scrollX,
                center: unit / 2
            };

            this.blackCache.push(bounds);
        });


        this.dom.maskImages.forEach((el, index) => {
            el.style.display = 'block';

            const scrollX = this.vars.target;
            const bounding = el.getBoundingClientRect();
            const bounds = {
                el: el,
                state: true,
                left: bounding.left + scrollX,
                right: bounding.right + scrollX,
                center: unit / 2
            }
            this.maskImageCache.push(bounds);
        });

        this.dom.animate.forEach((el, index) => {
            el.style.display = 'block';

            const scrollX = this.vars.target;
            const bounding = el.getBoundingClientRect();
            const bounds = {
                el: el,
                state: true,
                left: bounding.left + scrollX,
                right: bounding.right + scrollX,
                center: unit / 2
            }

            this.animateCache.push(bounds);
        });
        
        this.dom.section.style.width = `${this.vars.width}px`;
        this.vars.bounding = boundingTotal - this.vars.width;
    }
    
    run() {

        this.dom.divs.forEach(this.inViewport);
        this.dom.maskImages.forEach(this.loadImage);
        this.dom.animate.forEach(this.animate);
        /*
         *  top tabs code 
         */
        if( this.vars.current < this.clientsSectionOffset || this.dom.header.hasClass('active') ) {
            this.dom.header.removeClass('show-tabs sticky--no-bg');
        }
        else if( this.vars.current > this.clientsSectionOffset && this.vars.current < this.teamSectionOffset ) {
            this.dom.header.addClass('show-tabs sticky--no-bg');
            this.dom.tabs.addClass('change-color').eq(1).addClass('active').siblings().removeClass('active');
        }
        else if( this.vars.current > this.teamSectionOffset ) {
            this.dom.header.addClass('show-tabs sticky--no-bg');
            this.dom.tabs.removeClass('change-color').eq(2).addClass('active').siblings().removeClass('active');
        }
        // (this.vars.current > this.dom.divs[0].offsetWidth) ? this.dom.logo.removeClass('change-color') : this.dom.logo.addClass('change-color');
        if(this.native) {
            this.dom.section.style[this.prefix] = `translate3d(${this.vars.current * -1}px,0,0)`;
        } else {
            this.dom.section.style[this.prefix] = this.getTransform(this.vars.current * -1);
        }
        
        super.run();
    }

    calc(e) {
        if(this.animating) return;

        const delta = e.deltaY || e.deltaX;
        
        this.vars.target += delta * -0.5;
        this.clampTarget();
    }

    loadImage(el, index) {
        if(!this.maskImageCache || this.resizing) return;
        
        const cache = this.maskImageCache[index];
        
        const current = this.vars.current;
        const left = Math.round(cache.left - current);
        const right = Math.round(cache.right - current);
        const inview = right > 0 && left < this.vars.width;

        if(inview) {         
            LoadMaskImage(el);
            this.maskImageCache.splice(index, 1);
            this.dom.maskImages.splice(index, 1);
        }
    }
    
    inViewport(el, index) {
        
        if(!this.cache || this.resizing) return;
        
        const cache = this.cache[index];
        const current = this.vars.current;
        const left = Math.round(cache.left - current);
        const right = Math.round(cache.right - current);
        const inview = right > 0 && left < this.vars.width;
                
        if(inview) {
            if( (left + el.offsetWidth) - this.dom.hamMenu.offset().left >= 0  && ( this.dom.hamMenu.offset().left + this.dom.hamMenu.width() )  - left >=0 ) {
                if(cache.isBlack) {
                    this.dom.hamMenu.addClass('change-color');
                }
                else {
                    this.dom.hamMenu.removeClass('change-color');                    
                }
            }


            if( (left + el.offsetWidth) - this.dom.logo.offset().left >= 0  && ( this.dom.logo.offset().left + this.dom.logo.width() ) - left >=0 ) {
                if(cache.isBlack) {
                    this.dom.logo.addClass('change-color');
                }
                else {
                    this.dom.logo.removeClass('change-color');
                }
            }
        }
    }

    animate(el, index) {
        if(!this.animateCache || this.resizing) return;
        
        const cache = this.animateCache[index];
        
        const current = this.vars.current;
        const left = Math.round(cache.left - current);
        const right = Math.round(cache.right - current);
        const inview = right > 0 && left < this.vars.width;

        if(inview) {         
            animateChildren(el);
            this.animateCache.splice(index, 1);
            this.dom.animate.splice(index, 1);
        }
    }

    off() {
        super.off();

        this.dom.navigation.off('click');

        this.dom.team.off('mouseenter', this.handleMouseOver);

        this.dom.clients
            .off('mouseenter', this.hoverClientsAnimationEnter)
            .off('mouseleave', this.hoverClientsAnimationLeave);

        this.dom.workWithUs
            .off('mouseenter', this.hoverWorkAnimationEnter.bind(this))
            .off('mouseleave', this.hoverWorkAnimationLeave);

        this.dom.tabs.off('click');

        // this.pageSlider.slick('unslick');
    
    }

}

export default MeetingsScroll;


// WEBPACK FOOTER //
// ./app/components/scrolling/meetings-scroll.js